'use client';
import { logoutApi } from './useApi';
import { clearPersistedUserState } from './userStateStorage';

// 退出登录后，返回首页配置
export const logoutToHomePage = ['/account', '/team-account'];
// 退出登录
export const handleLogout = async () => {
  clearPersistedUserState();
  await logoutApi();
  window.location.href = `/login?s_url=${encodeURIComponent(
    window.location.href
  )}`;
};

// 退出登录但保持在当前页面（用于 S 大会等不希望跳转登录页的场景）
export const handleLogoutStay = async () => {
  clearPersistedUserState();
  await logoutApi();
  if (window.location.pathname === '/case/activity/summit/chat') {
    window.location.href = '/case/activity/summit';
    return;
  }
  window.location.reload();
};

// 前往登录
export const handleLogin = () => {
  if (window === undefined) return;
  window.location.href = `/login?s_url=${encodeURIComponent(
    window.location.href
  )}`;
};
